import React, { useContext } from "react";
import { Layer, Source } from "react-map-gl";
import { OBJECT_TYPE } from "common/constants";
import { colors } from "../../../stitches.config";
import { LayerContext } from ".";
import {
  getFillColorPolygonsLayer,
  getFillPatternPolygonsLayer,
  getFillPointsLayer,
  getLabelLinesLayer,
  getLabelPolygonsLayer,
  getLinesLayer,
  getOutlineClickPolygonsLayer,
  getOutlineHoverPolygonsLayer,
  getOutlinePointsLayer,
  getOutlinePolygonsLayer,
  getOutlineSelectedPointsLayer,
  getSelectedPointsLayer,
} from "./utils/customMaps";

export const viewsSourceId = "saved-views-source";
export const viewsLayerId = "saved-views";
export const group = "savedViews";

export const SAVED_VIEW_MIN_ZOOM = 13;

const SavedViewsLayer = ({ savedViewId }: { savedViewId: string }) => {
  const { isLayerVisible, mapNonce } = useContext(LayerContext);

  const viewTiles = [
    `${window.env.APPLICATION_URL}/api/tiles/views/${savedViewId}/{z}/{x}/{y}?nonce=${mapNonce}`,
  ];

  const layerId = `${viewsLayerId}-${savedViewId}`;
  const sourceId = `${viewsSourceId}-${savedViewId}`;
  const customMapSourceLayer = OBJECT_TYPE.CUSTOM_MAP_GEOMETRY;
  const visibility =
    isLayerVisible({ group, id: savedViewId }) ? "visible" : "none";

  return (
    <Source
      id={sourceId}
      tiles={viewTiles}
      type="vector"
      minzoom={SAVED_VIEW_MIN_ZOOM}
      //@ts-ignore - the TS types for mapbox gl leave a lot to be desired
      promoteId="id"
    >
      <Layer
        id={layerId}
        type="circle"
        source-layer="src"
        layout={{
          visibility:
            isLayerVisible({ group, id: savedViewId }) ? "visible" : "none",
        }}
        paint={{
          "circle-opacity": 1,
          "circle-stroke-opacity": 1,
          "circle-radius": 5,
          "circle-stroke-width": 1.5,
          "circle-stroke-color": colors.white.value,
          "circle-color": colors.blue500.value,
        }}
      />
      {getLinesLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
        isObject: true,
      })}
      {getFillPointsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getOutlinePointsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getSelectedPointsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getOutlineSelectedPointsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getFillColorPolygonsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getFillPatternPolygonsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getOutlinePolygonsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getLabelLinesLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getLabelPolygonsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getOutlineClickPolygonsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
      {getOutlineHoverPolygonsLayer({
        id: layerId,
        sourceLayer: customMapSourceLayer,
        visibility,
      })}
    </Source>
  );
};

export default SavedViewsLayer;
